import { auth0Client } from '@/auth/Auth0Client';
import { getAppConfig } from '@/utils/config';

import { redirect } from 'react-router-dom';

// Enforces auth on non publicly released variants
// Redirects to /restricted if user is not logged in or not an AI2 email user
// Allows AI2 user emails to pass through
export const privateEnvLoader = async () => {
  const allowAnonymousAccess = getAppConfig(
    (_) => _.auth.allow_anonymous,
    false,
  );

  // noop for publicly launched variants
  if (allowAnonymousAccess) {
    return null;
  }

  // see if user is already logged in
  const isAuthenticated = await auth0Client.isAuthenticated();

  // enforce login for non-publicly launched variants
  if (!isAuthenticated) {
    if (
      !window.location.search.includes('code=') &&
      !window.location.search.includes('state=')
    ) {
      await auth0Client.login();
      return null; // Exit early if there's already a login in progress
    }
  }

  // if the user was prompted to login in the block above, they will be redirected back here
  // it takes a few seconds for the auth client to be ready with the logged in user
  // so poll every second until the user is settled
  // this wait only affects internal users, really only the first time they log in
  let auth0User = await auth0Client.getUserInfo();
  while (!auth0User) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    auth0User = await auth0Client.getUserInfo();
  }

  const emailRegex = getAppConfig(
    (_) => _.auth.email_domain_regex,
    '.*@allenai\\.org$',
  );
  const userEmail = auth0User?.email || '';
  if (!userEmail.match(emailRegex)) {
    return redirect('/restricted');
  }

  return null;
};
